// extracted by mini-css-extract-plugin
export default {"page":"aL","top_block":"bL","heading":"cL","inner_text":"eL","starter_text":"fL","starter_cta":"gL","summary_block":"hL","cartsummary_wrap":"iL","price":"jL","pricing_wrap":"kL","summary_block_mob":"lL","summary":"mL","pricing_heading":"nL","products_summary":"oL","summary_line":"pL","summary_price":"qL","summary_title":"rL"};
    if(module.hot) {
      // 1715091680079
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  